import router from "@/router";
import qs from "qs";
import { nanoid } from "nanoid";
import Cookies from "js-cookie";
import httpClient from "@/mixins/httpClient";

export const state = {
  currentUser: localStorage.getItem('authUser'),
  token: Cookies.get('token'),
  refresh_token: Cookies.get('refresh_token'),
  isAuthError: false
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
  },
  SET_ACCESS_TOKEN(state, token) {
    state.token = token;
  },
  SET_REFRESH_TOKEN(state, refresh_token) {
    state.refresh_token = refresh_token;
  },
  SET_AUTH_ERROR(state, value) {
    state.isAuthError = value
  }
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },
  token(state) {
    return state.token
  },
  refreshToken(state) {
    return state.refresh_token
  },
  currentUser(state) {
    return state.currentUser
  }
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {
    dispatch('validate')
  },

  updateCurrentUser({ commit }, user) {
    localStorage.setItem("authUser", JSON.stringify(user));

    commit("SET_CURRENT_USER", user);
  },

  oneLoginDispatch() {
    const params = qs.stringify({
      client_id: process.env.VUE_APP_ONE_LOGIN_CLIENT_ID,
      redirect_uri: `${process.env.VUE_APP_DASHBOARD_URL}/oauth/callback`,
      response_type: "code",
      scope: "openid profile groups",
      state: nanoid(32),
      nonce: nanoid(32)
    });

    const url = `${process.env.VUE_APP_ONE_LOGIN_URL}/oidc/2/auth?${params}`;

    window.location.assign(url);
  },

  oneLoginCallback({ commit }, search) {
    const code = qs.parse(search.replace("?", "")).code;

    httpClient.methods.apiPost(`${process.env.VUE_APP_API_URL}/security/one-login/finalize`, { code: code }, true).then((data) => {
      Cookies.set('token', data.token, { expires: 365 });
      Cookies.set('refresh_token', data.refreshToken, { expires: 365 });

      commit("SET_ACCESS_TOKEN", data.token);
      commit("SET_REFRESH_TOKEN", data.refreshToken);
      commit('SET_CURRENT_USER', data.user);

      sessionStorage.clear();

      localStorage.setItem("authUser", JSON.stringify(data.user));

      router.push(router.currentRoute.query.redirect || "/");
    }).catch(() => {
      router.push("/login");
    })
  },

  async logIn({ commit }, { email, password }) {
    return httpClient.methods.apiPost(`${process.env.VUE_APP_API_URL}/security/authenticate`, { email, password }, true).then((data) => {
      Cookies.set('token', data.token, { expires: 365 });
      Cookies.set('refresh_token', data.refreshToken, { expires: 365 });

      commit("SET_ACCESS_TOKEN", data.token);
      commit("SET_REFRESH_TOKEN", data.refreshToken);
      commit('SET_CURRENT_USER', data.user);

      sessionStorage.clear();

      localStorage.setItem("authUser", JSON.stringify(data.user));

      router.push(router.currentRoute.query.redirect || "/");
    }).catch((error) => {
      return {
        errors: error.response ? error.response.data.message : null
      };
    })
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_CURRENT_USER', null);

    Cookies.remove("token");
    Cookies.remove("refresh_token");

    commit("SET_ACCESS_TOKEN", null);
    commit("SET_REFRESH_TOKEN", null);

    sessionStorage.clear();

    localStorage.removeItem('authUser');
  },

  refreshTokens({ commit }, { token, refreshToken }) {
    Cookies.set('token', token, { expires: 365 });
    Cookies.set('refresh_token', refreshToken, { expires: 365 });

    commit("SET_ACCESS_TOKEN", token);
    commit("SET_REFRESH_TOKEN", refreshToken);
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  // eslint-disable-next-line no-unused-vars
  validate({ commit, state }) {
    if (!state.currentUser) return Promise.resolve(null)
    const user = !localStorage.getItem('authUser') || localStorage.getItem('authUser') === 'undefined' ? null : JSON.parse(localStorage.getItem('authUser'));
    commit('SET_CURRENT_USER', user)

    window.addEventListener('storage', () => {
      const user = localStorage.getItem('authUser');
      if (user === 'undefined' || !user) {
        router.push("/logout");
      }
    }, false);

    return user;
  },
}

